import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import {
  PromptFragmentsList,
  CreatePromptFragment,
  UpdatePromptFragment,
} from "./pages";

export const PromptFragmentsRouter = [
  <Route
    path="/prompt-fragments"
    element={
      <ProtectedRoute roles={["Any"]}>
        <PromptFragmentsList />
      </ProtectedRoute>
    }
  />,

  <Route path="/prompt-fragment">
    <Route
      path="create"
      element={
        <ProtectedRoute roles={["Any"]}>
          <CreatePromptFragment />
        </ProtectedRoute>
      }
    />
    <Route
      path=":id/update"
      element={
        <ProtectedRoute roles={["Any"]}>
          <UpdatePromptFragment />
        </ProtectedRoute>
      }
    />
  </Route>,
];
